import React, { useContext, useEffect, useReducer } from 'react';
import {
  CabsLandingContext,
  CabsLandingDispatchContext
} from '../../../CabsLandingContext';
import { cabsLandingWidgetInfo } from '../../../cabsLandingWidgetInfo';
import { StopOverInput } from './StopOverInput';

export const StopOvers = ({ widgetMap }) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const dispatch = useContext(CabsLandingDispatchContext);

  const { stopOvers } = cabsLandingContext;

  return (
    <>
      {stopOvers && stopOvers.length > 0 ? (
        <>
          {stopOvers.map((cityLocation, idx) => {
            return (
              <StopOverInput
                stopOverId={idx}
                cityLocation={cityLocation}
                widgetComponent={widgetMap.get(
                  cabsLandingWidgetInfo.STOPOVER_CITY_LOCATION_WIDGET
                )}
              />
            );
          })}
        </>
      ) : null}
    </>
  );
};
